var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_3360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 22.1666V19.8333H7.00033V11.6666C7.00033 10.0527 7.48644 8.61867 8.45866 7.3645C9.43088 6.11034 10.6948 5.28881 12.2503 4.89992V2.33325H15.7503V4.89992C17.3059 5.28881 18.5698 6.11034 19.542 7.3645C20.5142 8.61867 21.0003 10.0527 21.0003 11.6666V19.8333H23.3337V22.1666H4.66699ZM14.0003 25.6666C13.3587 25.6666 12.8094 25.4381 12.3524 24.9812C11.8955 24.5242 11.667 23.9749 11.667 23.3333H16.3337C16.3337 23.9749 16.1052 24.5242 15.6482 24.9812C15.1913 25.4381 14.642 25.6666 14.0003 25.6666Z",
    fill: "#0028B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_3360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoti);
export default __webpack_public_path__ + "static/media/icon_noti.14a259ed79074fa3b718f1dcd5b28f17.svg";
export { ForwardRef as ReactComponent };